function setupFragments(){
    setTimeout(()=>{
        //Calculate screen width so we can shape stuff accordingly.
        let windowWidth = window.screen.width >= 920? "wide" : "narrow";
        let screenOffset = window.screen.width >= 920? 14 : 0;
        let containerWidth = window.getComputedStyle(document.querySelector("#contentContainer")).width.replaceAll("px","");
        let containerLeft = window.screen.width >= 920? document.querySelector("#contentContainer").offsetLeft : 0;
        let containerHeight = window.getComputedStyle(document.querySelector("#contentContainer")).height.replaceAll("px","");

        // Make them wiggle.
        let myNavs = [...document.querySelectorAll(".navFragment")]
        myNavs.forEach(nav => {
            if(nav.classList.contains("docked")) nav.classList.remove("docked");
            nav.style.animation = `breathe ${Math.floor((Math.random() * 4)+.5).toString()}s infinite`
            nav.addEventListener("mouseover", e => nav.classList.add("navFragmentHovered"))
            nav.addEventListener("mouseleave", e => nav.classList.remove("navFragmentHovered"))
        })
        //Calculate the number of menu items and the angles you'll need.
        let myAngle = 360 / myNavs.length;
        myNavs.reduce((a, c, i)=>{
            let useAngle = windowWidth === "wide"? a : (a/3 + 90 + myAngle)
            //Center the fragments.
            c.style.left = `${(containerWidth / 2) + containerLeft - 125}px`
            c.style.top = `${(containerHeight / 2) + (windowWidth === "wide"? 70 : 0)}px`
            // Rotate the fragments.
            c.style.rotate = (windowWidth === "narrow"? (a / 3) + 120 : a).toString() + "deg";
            // Flip any updside-down text right-side-up.
            if(90 <= useAngle && useAngle <= 270){
                c.querySelectorAll("h2, h4").forEach(node => node.style.rotate = "180deg");
            }
            // Now add padding so their points meet in roughly the same place.
            let fragWidth = Math.floor(Number(window.getComputedStyle(c).width.replaceAll("px",""))); //this might break if theres a perfectly round width value
            if(fragWidth < 250){
             c.style.paddingRight = `${(windowWidth === "wide" ? 260 : 90 + myAngle) - fragWidth}px`;
            }
            // Finally, change their X and Y coordinates so they point towards the middle.
            if(windowWidth === "wide"){
                c.style.translate = `${Math.floor(Math.cos(a *Math.PI/180)* screenOffset)}rem ${Math.floor(Math.sin(a * Math.PI/180)* screenOffset)}rem`;
            } else {
                c.style.translate = `${Math.floor(Math.cos(((a / 3) + 120 )* Math.PI/180) * -14) }rem ${Math.floor(Math.sin(((a / 3) + 120 )* Math.PI/180) * -17)}rem`;

            }
            return a + myAngle;
        }, myAngle)
    },100)
}

function dockFragments(){
    let windowWidth = window.screen.width >= 920? "wide" : "narrow";
    let myNavs = [...document.querySelectorAll(".navFragment")]
    let myAngle = 360 / myNavs.length;
        myNavs.forEach((nav, i) => {if(!nav.classList.contains("docked")) nav.classList.add("docked")
        nav.style.top = `${20 + i * 100}px`;
        let fragWidth = Math.floor(Number(window.getComputedStyle(nav).width.replaceAll("px",""))); //this might break if theres a perfectly round width value
            if(fragWidth < 250){
             nav.style.paddingRight = `${(windowWidth === "wide" ? 260 : 90 + myAngle) - fragWidth}px`;
            }
        })
}

export  {setupFragments, dockFragments}